import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  position: relative;
  font-size: 0.9px;
  cursor: pointer;
  height: 90%;
  width: 95%;
  box-sizing: border-box;

  .id {
    display: none;
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.03);
  }

  &.small {
    font-size: 0.8px;
    border: 1px solid rgba(255, 255, 255, 0.1);

    .image {
      background-size: contain;
    }
  }

  &.white {
    .image {
      top: 50em;
      left: 12px;
      right: 12px;
      bottom: 0;
      filter: brightness(1) contrast(1);
      background-size: contain !important;
      background-position: center center !important;
    }
  }
`;

export const Video = styled.video`
  object-fit: cover;
  filter: brightness(1.2);
`;

export const Header = styled.div``;

export const Id = styled.div`
  font-size: 13em;
  color: #aaa;
`;

export const Title = styled.h1`
  padding: 0;
  margin: 0;
  font-size: 21em;
  opacity: 0.8;
  font-weight: 200;
`;

export const By = styled.div`
  color: #aaa;
`;

export const Image = styled.div`
  position: absolute;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  top: 40em;
  left: 0;
  right: 0;
  bottom: 0;
  filter: brightness(1.1) contrast(1.1);
`;

export const Points = styled.div`
  font-size: 1em;
  position: absolute;
  right: -2em;
  bottom: 300em;
`;

export const Gap = styled.div`
  flex: 1;
`;
